import { render, staticRenderFns } from "./FloorAreaWorkspace.vue?vue&type=template&id=7808357a&"
import script from "./FloorAreaWorkspace.vue?vue&type=script&lang=ts&"
export * from "./FloorAreaWorkspace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports